import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GlobalService } from '../../services/global.service';
import { UntypedFormBuilder } from '@angular/forms';
import { HttpService } from '../../services/http.service';
import { Globals } from '../../models/globals.model';
import { MatTableDataSource } from '@angular/material/table';
import { evaluateFormula } from '../kpi-models/evaluateFormula';
import { evaluateFormulaResults } from '../kpi-models/evaluateFormulaResults';
import { EvaluateFormulaModelComponent } from '../evaluate-formula-model/evaluate-formula-model.component';
import { AlertComponent } from '../../common/alert/alert.component';
import { KPIFormulaBuilderService } from 'src/app/services/kpi-formula-builder.service';

@Component({
  selector: 'app-evaluate-formula-results',
  templateUrl: './evaluate-formula-results.component.html',
  styleUrls: ['./evaluate-formula-results.component.scss']
})
export class EvaluateFormulaResultsComponent implements OnInit {
  isLoader: boolean;
  formulaDataSource: MatTableDataSource<evaluateFormulaResults>;
  mainFormulaId = this.data.formulaId;
  mainFormulaExpression = this.data.formulaExpression;
  mainFormulaName = "";
  mainFormulaValue = 0;
  mainFormulaUOM = "";
  displayedColumns: string[] = ['ConstantTag', 'ValueDataSource', 'UOM', 'EntryType'];
  apiUri: string;

  constructor(
    public dialogRef: MatDialogRef<EvaluateFormulaResultsComponent>,
    public globals: GlobalService,
    public dialog: MatDialog,
    public fb: UntypedFormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly httpService: HttpService,
    private readonly kpiFormulaService: KPIFormulaBuilderService,
    public global: Globals
  ) {
    this.apiUri = this.global.config.foundationPlatformApi_client_resourceUri;
  }

  ngOnInit(): void {
    this.isLoader = false;
    this.loadInitialData();
  }

  loadInitialData() {
    this.kpiFormulaService.getTestFormulaResult(this.mainFormulaId).subscribe((result: evaluateFormulaResults[]) => {
      let itemIndex = result.findIndex(item => item.entryType == 'C');  // Moving constant to front
      if (itemIndex > -1) {
        result.splice(0, 0, result.splice(itemIndex, 1)[0]);  // Moving constant to front
      }

      itemIndex = result.findIndex(item => item.entryType == 'O');

      if (itemIndex == -1) {
        this.globals.showAlert(AlertComponent, { success: false, message: "Error while evaluating formula" });
      } else {
        this.mainFormulaName = result[itemIndex].tagId;
        this.mainFormulaValue = result[itemIndex].tagValue;
        this.mainFormulaUOM = result[itemIndex].uom;

        result.splice(result.length - 1, 0, result.splice(itemIndex, 1)[0]);  // Moving output to end
        result.pop();
      }
      this.formulaDataSource = new MatTableDataSource(result);
    });
  }

  /**Cancels the pop-up */
  onCancelClick(value: boolean): void {
    this.dialogRef.close(value);
  }

  backEvaluate() {
    this.dialogRef.close(true);

    const dataTbSent: any = {};
    this.kpiFormulaService.getFormulaDetailsOnKpiId(this.data.formulaId).subscribe((data: evaluateFormula[]) => {
        dataTbSent.FormulaDetails = data;
        const dataToPass = {
          title: 'Evaluate Formula',
          formulaName: this.data.formulaName,
          formulaFrequency: this.data.formulaFrequency,
          formulaExpression: this.data.formulaExpression,
          data: dataTbSent
        };
        this.dialog.open(EvaluateFormulaModelComponent, {
          width: '1300px',
          disableClose: true,
          panelClass: 'confirm-modalbox',
          data: dataToPass
        });
      }, (error) => {
        console.log(error);
      });
  }

}
